module.exports = __webpack_public_path__ + "static/media/customize-dashboard.692776f5.svg";